import { Box, Button, ButtonGroup, HStack, Image, Stack, Text } from '@chakra-ui/react';

import SolidButton from '@/client/components/shared/buttons/SolidButton';
import { useAIAgentStore } from '../../AIAgentStore';
import { useGetPublicImage } from '@/client/services/hooks/media/useGetPublicImage';

export default function AIAgentNudgePopover() {
  const { renderNudgePopup, setRenderNudgePopup, setActiveTab, setEddyDrawerIsOpen } =
    useAIAgentStore();
  const { getPublicImage } = useGetPublicImage();

  return renderNudgePopup ? (
    <Box
      position="fixed"
      bottom={150}
      right={30}
      zIndex={999}
      backgroundColor="white"
      borderRadius="16px"
      boxShadow="1px 12px 47px 0px rgba(0, 0, 0, 0.45)"
      padding={8}
      width="532px"
    >
      <HStack gap={6} alignItems="flex-start">
        <Image src={getPublicImage('continu/app-images/eddy-nudge.svg')} alt="Nudge Popover" />

        <Stack gap={4}>
          <Stack gap={2}>
            <Text fontSize="22px" fontWeight={600} color="baseBlack">
              Want Answers Faster?
            </Text>

            <Text fontSize="16px" fontWeight={600} color="neutral.600">
              Chat with Eddy to get quick answers or summaries.
            </Text>
          </Stack>

          <ButtonGroup>
            <Button variant="cancel" onClick={() => setRenderNudgePopup(false)}>
              Dismiss
            </Button>

            <SolidButton
              onClick={() => {
                setActiveTab('conversation');
                setRenderNudgePopup(false);
                setEddyDrawerIsOpen(true);
              }}
            >
              Try Eddy Out
            </SolidButton>
          </ButtonGroup>
        </Stack>
      </HStack>
    </Box>
  ) : null;
}
